<template>
  <div id="attendance" class="card-custom">
    <header>
      <nav class="align-items-center">
        <div class="title position-relative">
          <a class="navigation-text" :href="'#/leave/'">{{$t('leave')}} {{text}}</a>
        </div>
        <ul class="header__navbar">
          <li class="header__item">
            <a class="header__link">
              <transition name="slide-fade">
                <button class="header--button m-1" v-if="show" key="on" @click="show = false">
                  <svg viewBox="0 0 24 24" class="header--icon">
                    <title>Close</title>
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                      fill="currentColor"
                      d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                    />
                  </svg>
                </button>
                <button class="header--button m-1" v-else key="off" @click="show = true">
                 <svg xmlns="http://www.w3.org/2000/svg" x="120px" y="0px"
width="25" height="25"
viewBox="0 0 172 172"
style=" fill:#000000; margin-right: 12px;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M72.24,10.32c-32.26344,0 -58.48,26.21656 -58.48,58.48c0,32.26344 26.21656,58.48 58.48,58.48c12.76563,0 24.56375,-4.11187 34.185,-11.0725l45.2575,45.15l9.675,-9.675l-44.72,-44.8275c8.78813,-10.23937 14.0825,-23.52906 14.0825,-38.055c0,-32.26344 -26.21656,-58.48 -58.48,-58.48zM72.24,17.2c28.54125,0 51.6,23.05875 51.6,51.6c0,28.54125 -23.05875,51.6 -51.6,51.6c-28.54125,0 -51.6,-23.05875 -51.6,-51.6c0,-28.54125 23.05875,-51.6 51.6,-51.6z"></path></g></g></svg>
                </button>
              </transition>
            </a>
            <!-- filters -->
            <transition name="dropdown">
              <div class="dropdown__menu" v-bind:class="{ active: show }" v-if="show">
                <form class="ml-5">
                  <date-picker
                      v-model="filter.month"
                      type="month"
                      @change="getLeaveMonthly()"
                      placeholder="Search by Month"
                    >
                    </date-picker>
                    <date-picker
                      v-model="filter.year"
                      @change="getLeaveYearly()"
                      type="year"
                      placeholder="Search by Year"
                    >
                    </date-picker>
                </form>
              </div>
            </transition>
          </li>
        </ul>
      </nav>
    </header>
      <section class="chart-position">
        <apexchart v-if="seriesChart.length > 0 || seriesChart.length == undefined"
          type="pie"
          width="95%"
          height="180"
          :options="chartOptionsChart"
          :series="seriesChart"
        ></apexchart>
        
      </section>
  </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import DatePicker from 'vue2-datepicker';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
export default {
  name: 'pie-attendance',
  components: {DatePicker},
  data() {
    const monthly = this.$moment(new Date).format("YYYY-MM")
    return {
      apiUrl: {
        leaveChart: window.AppConfig.apiUrl + "new-dashboard"
      },
      monthly: monthly,
      filter: {
        month: monthly,
        year: null,
      },
      text: "",
      show: false,
      leaveData: [],
      seriesChart: [],
      chartOptionsChart: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Disetujui', 'Diminta', 'Ditolak'],
        labelsPosition: 'bottom',
        responsive: [
          {
            breakpoint: 480,
            position: 'bottom',
            options: {
              chart: {
                width: 400,
              },
              legend: {
                position: 'right',
              },
            },
          },
        ],
      },
    };
  },

  watch: {
    "filter.year"(value){
      if(value !==null) this.getLeaveYearly()
    }
  },

  mounted(){
    this.getLeaveMonthly()
  },

  methods: {
    async getLeaveMonthly(){
      const Y = this.$moment
      const resp = await this.$http.get(this.apiUrl.leaveChart + "?leave_month=" + this.$moment(this.filter.month).format("YYYY-MM"))
      try {
        this.leaveData = resp.data.leave.monthly
        console.log(this.leaveData);
        this.text = Y(this.filter.month).format("MMM YYYY")
        this.seriesChart = [this.leaveData.approved, this.leaveData.requested, this.leaveData.rejected]
        this.show = false
        console.log("month", this.seriesChart);
      } catch (error) {
        console.log(error);
      }
    },

     async getLeaveYearly(){
      const Y = this.$moment
      const resp = await this.$http.get(this.apiUrl.leaveChart + "?leave_year=" + this.$moment(this.filter.year).format("YYYY"))
      try {
        this.leaveData = await resp.data.leave.year
        console.log(this.leaveData);
        this.text = Y(this.filter.year).format("YYYY")
        this.seriesChart = [this.leaveData.approved, this.leaveData.requested, this.leaveData.rejected]
        this.show = false
      } catch (error) {
        console.log(error);
      }
    },
  }
};
</script>

<style lang="scss">
#attendance {
  height: 40vh;
}
.chart-position {
  top: -78px;
  display: grid;
  position: static;
  bottom: 20px;
  left: 21px;
}
title {
  z-index: 1000;
}
ul,
li,
a {
  text-decoration: none !important;
}
.header {
  padding: 2rem 5rem 2rem 5rem;
  &__nav {
    position: relative;
  }
  &__navbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  &__item {
    padding: 1rem;
  }
  &--icon {
    width: 1.65rem;
    height: 1.65rem;
  }
  &--button {
    top: 0;
    right: 0;
    position: absolute;
    margin: 0;
    padding: 0;
    color: gray;
    cursor: pointer;
    border: 1px solid transparent;
    background-color: transparent;
    &:focus {
      outline: 0;
    }
  }
}
// Dropdown Menu

.dropdown__menu {
  right: 15%;
  top: 0;
  position: absolute;
  z-index: 10;
  height: 100%;
  min-width: 300px;
  //   margin-top: 0.5rem;
  overflow-y: auto;
  padding: 1rem 1rem 4rem 0rem;
  border-radius: 12px;
  background-color: white !important;
  //   background: #fff !important;
  border: 1px solid var(--color-gray);
  background-clip: padding-box;
  &-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.6);
    padding: 0.8rem 0 0.8rem 2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0 50px 50px 0;
    &:hover {
      color: #17bf63;
      background-color: rgba(79, 192, 141, 0.1);
    }
  }
  &-svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &-text {
    font-weight: 300;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

// Animation Menu Icon

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

// Dropdown Menu Animation

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 1s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

</style>